exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newQuotesPage .removeLineLink{margin-left:2em}.newQuotesPage .quoteTable{font-size:.8em}.newQuotesPage .quoteTable td{vertical-align:middle}.newQuotesPage .quoteTable th.planCol,.newQuotesPage .quoteTable th.totalCol{min-width:8em}.newQuotesPage .quoteTable th.reasonCol{min-width:14em}.newQuotesPage .primaryStar{font-size:20px;padding:0;margin-left:4px}.newQuotesPage .primaryStar:focus{outline:none}.newQuotesPage .actions .btn{margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/crm/new_quotes_page.scss
// module id = 813
// module chunks = 0